import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import ScheduleList from '@home/components/Search/ScheduleList.vue'
import * as accountTypes from '@account/store/types'
import calendarApi from '@calendar/api'
import { mapGetters } from 'vuex'
@Component({
    components: { ScheduleList },
    computed: {
        ...mapGetters({
            User: accountTypes.USER
        })
    }
})
export default class ScheduleSearchContainer extends Vue {
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    User!: account.User

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    scheduleList: ItemList<calendar.CalendarItem> = []
    pageNumber: number = 1
    loadMorePossible: boolean = true

    loadMore() {
        if (this.loadMorePossible) {
            this.pageNumber ++
            this.loadData()
        }
    }

    loadData() {
        const keyword = this.$route.query.keyword.toString()
        if (keyword) {
            var searchOptions: calendar.SearchOptions = {
                EwsFolderIDArray: null,
                FolderIDArray: null,
                ParentFolderID: null,
                Keyword: keyword,
                Status: null,
                Subject: null,
                Location: null,
                OrganizerName: null,
                OrganizerAddress: null,
                RequiredAttendees: null,
                OptionalAttendees: null,
                StartDate: null,
                EndDate: null,
                PersonCode: this.User.personCode,
                EumPageNumber: this.pageNumber,
                EumRowsPerPage: 15,
                EXTFIELD_1: null,
                EXTFIELD_2: null,
            }
            calendarApi.ews_calendar.searchCalendarEventList(searchOptions).then(res => {
                if (res.length) {
                    if (this.pageNumber > 1) {
                        this.scheduleList = [...(this.scheduleList || []), ...res]
                    } else {
                        this.scheduleList = res
                    }
                } else {
                    this.loadMorePossible = false
                }
            })
        }
    }

    created() {
        this.loadData()
    }
}